<template lang="html">
  <canvas :width="width" :height="height" />
</template>

<script>
export default {
  name: "TimelineCanvas",
  props: {
    width: {
      type: Number,
      default: () => 90
    },
    height: {
      type: Number,
      default: () => 90
    }
  },
  data() {
    return {
      $canvas: null,
      waveform: null,
      scale: 1,
      waveformColor: "#b892ff"
    };
  },
  computed: {
    show() {
      return this.$store.state.show.currentShow;
    }
  },
  mounted() {
    // Setup canvas.

    this.$canvas = this.$el;
    this.updateCanvas();
  },
  methods: {
    updateCanvas() {
      var scaleY = (amplitude, height) => {
        //console.log(amplitude, height);
        var range = 256;
        var offset = 128;
        return height - ((amplitude + offset) * height) / range;
      };
      var drawWaveform = (canvas, waveform, offsetX) => {
        var ctx = canvas.getContext("2d");

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (offsetX > waveform.length - canvas.width) {
          offsetX = waveform.length - canvas.width;
        }

        var waveformHeight = canvas.height / waveform.channels;

        for (
          let c = 0, offsetY = 0;
          c < waveform.channels;
          c++, offsetY += waveformHeight
        ) {
          //console.log("channel", c);
          var channel = waveform.channel(c);

          ctx.beginPath();

          var val;
          var position;

          var scale = this.scale;
          var canvas_width = canvas.width;
          var waveform_length = waveform.length;

          for (
            let x = 0, i = offsetX;
            x < canvas_width && i < waveform.length;
            x++, i++
          ) {
            position = Math.round(
              (x / (canvas_width * scale)) * waveform_length
            );
            val = channel.max_sample(position);
            //console.log(i);
            ctx.lineTo(x + 0.5, offsetY + scaleY(val, waveformHeight) + 0.5);
          }

          for (
            let x = canvas.width - 1, i = offsetX + canvas.width - 1;
            x >= 0;
            x--, i--
          ) {
            //console.log(i);
            position = Math.round(
              (x / (canvas_width * scale)) * waveform_length
            );
            val = channel.min_sample(position);

            ctx.lineTo(x + 0.5, offsetY + scaleY(val, waveformHeight) + 0.5);
          }

          ctx.closePath();
          ctx.strokeStyle = this.waveformColor;
          ctx.stroke();
          ctx.fillStyle = this.waveformColor;
          ctx.fill();
        }
      };
      drawWaveform(this.$canvas, this.$store.state.waveform.waveformData, 0);
    }
  }
};
</script>

<style lang="css" scoped>
canvas {
  background-color: white;
}
</style>
